export const MATERIAL_LISTING = "MATERIAL_LISTING";
export const EQUIPMENT_LISTING = "EQUIPMENT_LISTING";
export const GET_MATERIAL_DETAILS = "GET_MATERIAL_DETAILS";
export const GET_EQUIPMENT_DETAILS = "GET_EQUIPMENT_DETAILS";
